const scrollToTopWrp = document.querySelector('.scroll-to-top');
const scrollToTopBtn = scrollToTopWrp?.querySelector('.scrollToTop');

function showScrollToTop() {
	if (document.body.scrollTop > (window.innerHeight / 2) || document.documentElement.scrollTop > (window.innerHeight / 2)) {
		scrollToTopWrp?.classList.add('active');
	} else {
		scrollToTopWrp?.classList.remove('active');
	}
}

// Bound function for easy removal
const scrollHandler = () => {
	showScrollToTop();
};

if (scrollToTopWrp) {
	window.addEventListener('scroll', scrollHandler);
}

function scrollToTop() {
	window.scrollTo({
		top: 0,
		behavior: 'smooth'
	});
}

if (scrollToTopBtn) {
	scrollToTopBtn.addEventListener('click', () => {
		scrollToTop();
	});
}

// Cleanup function for potential use
window.cleanupScrollToTop = function () {
	window.removeEventListener('scroll', scrollHandler);
};